import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-down-right",
  "use": "icon-co-down-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-down-right\" id=\"icon-co-down-right\"><polyline points=\"15 10 20 15 15 20\" /><path d=\"M4 4v7a4 4 0 0 0 4 4h12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol